export const addressBook = {
  addNewShippingAddress: 'Add a new shipping address',
  editShippingAddress: 'Edit shipping address',
  areYouSureToDeleteAddress: 'Are you sure you want to delete this address?',
  addNewAddress: 'Add new address',
  addAddress: 'Add address',
  updateAddress: 'Update address',
  backToAddressList: 'Back to address list',
  button: {
    addAddress: 'Add Address',
    save: 'Save',
    cancel: 'Cancel',
    update: 'Update',
  },
  heading: {
    addAddress: 'Add Address',
    editAddress: 'Edit Address',
  },
};

export const addressCard = {
  default: 'Default',
  selected: 'Selected',
  setAsDefault: 'Set as default',
  shipTo: 'Ship To',
  billTo: 'Bill To',
  phoneNumber: 'Phone number',
  mobileNumber: 'mobile number',
};

export const addressForm = {
  title: 'Title',
  firstName: {
    label: 'First Name',
    placeholder: 'First Name',
  },
  lastName: {
    label: 'Last Name',
    placeholder: 'Last Name',
  },
  address1: 'Address 1',
  address2: 'Address 2 (Optional)',
  country: 'Country',
  city: {
    label: 'City',
    placeholder: 'City',
  },
  state: 'State/Province',
  zipCode: {
    label: 'ZIP Code/Postal Code',
    placeholder: 'ZIP Code/Postal Code',
  },
  phoneNumber: {
    label: 'Phone Number (Optional)',
    placeholder: '(555) 555 - 0123',
  },
  saveAsDefault: 'Save as default',
  chooseAddress: 'Choose address',
  streetAddress: 'Street Address',
  aptSuite: 'Apt, Suite',
  selectOne: 'Select One...',
  selectOneState: 'Select State/Province',
  setAsDefault: 'Set as default',
  titleRequired: 'Title is required.',
  userAddressAddSuccess: 'New address was added successfully!',
  userAddressUpdateSuccess: 'Address updated successfully!',
  userAddressDeleteSuccess: 'Address deleted successfully!',
  invalidAddress: 'Address is not valid. Please verify your input and try again or proceed with this address.',
  label: {
    name: 'Name',
    attn: 'Attn: Name/Ref No',
    bldg: 'Address line 1',
    houseNumberAndStreetName: 'Address line 2',
    cityAndPostalCode: 'City / Postal Code',
    mobileCity: 'City',
    mobileState: 'State / Province',
    mobileZipCode: 'ZIP Code / Postal Code',
    email: 'Email',
    telephone: 'Telephone',
    fax: 'Fax',
    mandatoryFields: ' You Must Fill Out These Fields',
  },
  placeholder: {
    name: 'Name',
    attn: 'Attn: Name/Ref No',
    bldg: 'Address line 1',
    streetName: 'Address line 2',
    select: 'Select Country',
    selectState: 'Select State/Province',
    postalCode: 'ZIP Code/Postal Code',
    email: 'Email',
    telephone: 'Telephone',
    fax: 'Fax',
  },
  button: {
    onetime: 'One Time Use',
    cancel: 'Cancel',
  },
  onetime: {
    successMsg: 'OneTime Address created successfully',
  },
};
export const addressMessages = {
  "setAsDefaultSuccessfully": "Address {{ streetAddress }} was successfully set as default"
};
export const addressValidation = {
  serviceUnavailable: 'We couldn\'t validate this address right now. Please try again.',
  validating: 'Validating address...',
  enteredAddress: 'What You Entered',
  // A. Confirm the recommended address (recommendation.png).
  confirmDialog: {
    title: 'Confirm Your Delivery Address',
    subtitle: 'Review the recommended changes',
    recommendedAddress: 'Recommended',
    back: 'Back',
    confirm: 'Confirm',
  },
  // B. Provide missing information (addition.png).
  missingInfoDialog: {
    title: 'Missing Information',
    subtitle: 'Does your building have multiple units?',
    inputLabel: 'Apt, suite, or unit',
    helperText: 'Leave blank if there are not multiple units',
    goBack: 'Go Back',
    continue: 'Continue',
  },
  // C. Fix the address (correction.png).
  fixDialog: {
    title: 'We Couldn\'t Verify Your Address',
    subtitle: 'Review the verification issues',
    issuesTitle: 'Verification Issues',
    body: 'We couldn\'t verify this address. Please review and correct it before continuing.',
    makeChanges: 'Make Changes',
    useEntered: 'Use Entered',
  },
};
export const address = {
  addressBook,
  addressForm,
  addressCard,
  addressMessages,
  addressValidation
};
